/** Workflows, templates, and schedules. */
export default [

  {
    path: '/workflows',
    name: 'Workflows',
    component: () => import('@/views/private/WorkflowsView.vue'),
    meta: {
      public: false,
      title: 'Workflows',
    },
  },

  {
    path: '/workflow/:workflowId',
    name: 'Workflow',
    component: () => import('@/views/private/WorkflowView.vue'),
    props: function(route) {
      return {
        workflowId: Number(route.params.workflowId),
      };
    },
    meta: {
      public: false,
      title: 'Workflow',
    },
  },

  {
    path: '/workflow-templates',
    name: 'WorkflowTemplates',
    component: () => import('@/views/private/WorkflowTemplatesView.vue'),
    meta: {
      public: false,
      title: 'Workflow Templates',
    },
  },

  {
    path: '/workflow-template/:workflowTemplateId',
    name: 'Workflow Template',
    component: () => import('@/views/private/WorkflowTemplateView.vue'),
    props: function(route) {
      return {
        workflowTemplateId: Number(route.params.workflowTemplateId),
      };
    },
    meta: {
      public: false,
      title: 'Workflow Template',
    },
  },

  {
    path: '/schedules',
    name: 'Schedules',
    component: () => import('@/views/private/SchedulesView.vue'),
    meta: {
      public: false,
      title: 'Schedules',
    },
  },

];
